(function () {
  'use strict';

  function getOverlay(root) {
    var section = root.closest('.t4s-section-livish-floating-action');
    return section ? section.querySelector('[data-livish-floating-overlay]') : null;
  }

  function close(root) {
    root.classList.remove('is-open');
    var toggle = root.querySelector('[data-livish-floating-toggle]');
    var overlay = getOverlay(root);
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    if (overlay) overlay.classList.remove('is-open');
  }

  function closeToolbarCenterAction() {
    document.querySelectorAll('[data-toolbar-fab].is--open').forEach(function (fab) {
      fab.classList.remove('is--open');
      var toggle = fab.querySelector('[data-toolbar-fab-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
    document.querySelectorAll('[data-toolbar-fab-overlay].is--visible').forEach(function (overlay) {
      overlay.classList.remove('is--visible');
    });
  }

  function openFaceAge() {
    var attempts = 0;
    var timer = window.setInterval(function () {
      var widgetButton = document.getElementById('face-age-button');
      attempts += 1;
      if (widgetButton) {
        window.clearInterval(timer);
        widgetButton.click();
      } else if (attempts >= 20) {
        window.clearInterval(timer);
      }
    }, 250);
  }

  function findInTimmy(root, selector) {
    if (!root || !root.querySelector) return null;
    var match = root.querySelector(selector);
    if (match) return match;
    var elements = root.querySelectorAll('*');
    for (var i = 0; i < elements.length; i++) {
      if (!elements[i].shadowRoot) continue;
      match = findInTimmy(elements[i].shadowRoot, selector);
      if (match) return match;
    }
    return null;
  }

  function forceAskTimmyOpen(widget) {
    var windowContainer = findInTimmy(widget, '.chat-window-container');
    var chatContainer = findInTimmy(widget, '.askTimmy-chat-container');
    var widgetWrapper = findInTimmy(widget, '.chat-widget');
    if (windowContainer) {
      windowContainer.classList.remove('askTimmy-hide');
      windowContainer.classList.add('askTimmy-show');
    }
    if (chatContainer) {
      chatContainer.classList.remove('askTimmy-hide');
      chatContainer.classList.add('askTimmy-show');
    }
    if (widgetWrapper) {
      widgetWrapper.classList.remove('askTimmy-bubble');
      widgetWrapper.classList.add('askTimmy-chat');
      widgetWrapper.classList.add('chat');
    }
  }

  function openAskTimmy() {
    var attempts = 0;
    var timer = window.setInterval(function () {
      var widget = document.querySelector('chat-widget');
      attempts += 1;
      if (widget) {
        window.clearInterval(timer);
        var trigger = findInTimmy(widget, '.askTimmy-chat-bubble-container');
        if (trigger) trigger.click();
        window.setTimeout(function () { forceAskTimmyOpen(widget); }, 100);
      } else if (attempts >= 20) {
        window.clearInterval(timer);
      }
    }, 250);
  }

  function openJuphyChat() {
    var attempts = 0;
    var timer = window.setInterval(function () {
      var chatButton = document.getElementById('widget-chat-button');
      var closeButton = document.getElementById('widget-close-button');
      attempts += 1;
      if (chatButton) {
        window.clearInterval(timer);
        var isOpen = closeButton && closeButton.classList.contains('juphy-button-active');
        if (isOpen && closeButton) {
          closeButton.click();
        } else {
          chatButton.click();
        }
      } else if (attempts >= 20) {
        window.clearInterval(timer);
      }
    }, 250);
  }

  function setLauncherHidden(element, hidden) {
    if (!element) return;
    if (hidden) {
      if (!element.dataset.livishLauncherHidden) {
        element.dataset.livishLauncherHidden = 'true';
        element.dataset.livishOriginalOpacity = element.style.getPropertyValue('opacity');
        element.dataset.livishOriginalVisibility = element.style.getPropertyValue('visibility');
        element.dataset.livishOriginalPointerEvents = element.style.getPropertyValue('pointer-events');
      }
      element.style.setProperty('opacity', '0', 'important');
      element.style.setProperty('visibility', 'hidden', 'important');
      element.style.setProperty('pointer-events', 'none', 'important');
    } else if (element.dataset.livishLauncherHidden) {
      element.style.removeProperty('opacity');
      element.style.removeProperty('visibility');
      element.style.removeProperty('pointer-events');
      if (element.dataset.livishOriginalOpacity) element.style.setProperty('opacity', element.dataset.livishOriginalOpacity);
      if (element.dataset.livishOriginalVisibility) element.style.setProperty('visibility', element.dataset.livishOriginalVisibility);
      if (element.dataset.livishOriginalPointerEvents) element.style.setProperty('pointer-events', element.dataset.livishOriginalPointerEvents);
      delete element.dataset.livishLauncherHidden;
    }
  }

  function syncAppLaunchers(root) {
    var hideFaceAge = root.dataset.hideFaceAge === 'true';
    var hideAskTimmy = root.dataset.hideAskTimmy === 'true';
    var hideJuphy = root.dataset.hideJuphy === 'true';
    var widget = document.querySelector('chat-widget');
    setLauncherHidden(document.getElementById('face-age-button'), hideFaceAge);
    setLauncherHidden(widget && findInTimmy(widget, '.chat-nudges-bubble-container'), hideAskTimmy);
    setLauncherHidden(document.getElementById('widget-chat-container'), hideJuphy);
  }

  function init(root) {
    if (!root || root.dataset.livishFloatingInit) return;
    root.dataset.livishFloatingInit = 'true';
    var overlay = getOverlay(root);
    syncAppLaunchers(root);
    if (window.MutationObserver && document.body) {
      var syncTimer;
      new MutationObserver(function () {
        window.clearTimeout(syncTimer);
        syncTimer = window.setTimeout(function () { syncAppLaunchers(root); }, 50);
      }).observe(document.body, { childList: true, subtree: true });
    }

    root.addEventListener('click', function (event) {
      var faceAge = event.target.closest('[data-livish-floating-face-age]');
      var askTimmy = event.target.closest('[data-livish-floating-ask-timmy]');
      var juphyChat = event.target.closest('[data-livish-floating-juphy-chat]');
      var toggle = event.target.closest('[data-livish-floating-toggle]');
      var action = event.target.closest('.t4s-livish-floating__action');
      if (faceAge || askTimmy || juphyChat) {
        event.preventDefault();
        close(root);
        if (faceAge) openFaceAge();
        else if (askTimmy) openAskTimmy();
        else openJuphyChat();
      } else if (toggle) {
        var open = !root.classList.contains('is-open');
        closeToolbarCenterAction();
        root.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', open);
        if (overlay) overlay.classList.toggle('is-open', open);
      } else if (action) {
        close(root);
      }
    });

    if (overlay) {
      overlay.addEventListener('click', function () { close(root); });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-livish-floating]').forEach(init);
  }

  document.addEventListener('click', function (event) {
    document.querySelectorAll('[data-livish-floating].is-open').forEach(function (root) {
      if (!root.contains(event.target) && !event.target.closest('[data-livish-floating-overlay]')) close(root);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
